import { render, staticRenderFns } from "./CourseBuilderNavigationForm.vue?vue&type=template&id=cdb41790&scoped=true&"
import script from "./CourseBuilderNavigationForm.vue?vue&type=script&lang=js&"
export * from "./CourseBuilderNavigationForm.vue?vue&type=script&lang=js&"
import style0 from "./CourseBuilderNavigationForm.vue?vue&type=style&index=0&id=cdb41790&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb41790",
  null
  
)

export default component.exports